export default __webpack_public_path__ + "static/media/img-0700-san-marino-premium-face.ca5613a1.png";